import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateUserLanguageParams {
  userId: string; // server user id
  language: string;
}

export class UpdateUserLanguageRequest extends Request<IUpdateUserLanguageParams, IResult> {
  constructor(params: IUpdateUserLanguageParams) {
    super('updateUserLanguage', params);
  }
}
